import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { useSlideEnterAnimation } from "@hooks/useSlideEnterAnimation";

import classNames from "classnames";
import * as c from "./reviewBadges.module.scss";

const ReviewBadges = ({ className }) => {
  const data = useStaticQuery(graphql`
    query ReviewBadgesQuery {
      badges: allFile(
        filter: { extension: { regex: "/(jpg)|(jpeg)|(png)/" }, relativeDirectory: { eq: "review-badges/redesign" } }
        sort: { name: ASC }
      ) {
        nodes {
          image: childImageSharp {
            gatsbyImageData(height: 110, layout: CONSTRAINED, placeholder: NONE)
          }
          name
        }
      }
    }
  `);

  useSlideEnterAnimation();

  return (
    <div className={classNames(c.container, className)} data-transition="slide-enter-child">
      {data.badges.nodes.map(({ image, name }) => (
        <GatsbyImage
          key={name}
          className={c.badge}
          image={getImage(image)}
          imgStyle={{
            objectFit: "contain",
            objectPosition: "center center",
          }}
          alt=""
        />
      ))}
    </div>
  );
};

export default ReviewBadges;
